import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["row"]

  connect() {
    // Optional: Hide all on load
    this.rowTargets.forEach(row => row.classList.add('d-none'));
  }

  toggle(e) {
    if (e.target.closest('.button-row')) return;

    // Find *all* button-row elements on the page
    document.querySelectorAll('.button-row').forEach(row => {
      // Hide all rows
      row.classList.add('d-none');
    });

    // Show (or toggle) this one
    const currentRow = this.rowTarget;
    const isActive = !currentRow.classList.contains('d-none');
    if (!isActive) {
      currentRow.classList.remove('d-none');
    }
    // If it was open, it remains closed (no need to re-show).
  }
}